export default function () {
  const widgetName = 'multiScheduleFeature';
  const widgetOpts = multiScheduleFeatureOpts;

  $(`#${widgetName}`).append(
    '<div class="multiFeatureContent"><h3>Upcoming Events</h3></div>'
  );

  function setCharLimit(el, limit) {
    const text = el.text();
    return text.length > limit ? `${text.substring(0, limit)}...` : text;
  }

  function formatDate(el) {
    const datesMonth = el.text().slice(0, 3);
    const datesDay = el.text().slice(4, 7).replace(',', '');
    el.html(`<span>${datesMonth}</span><span>${datesDay}</span>`);
  }

  $(`#${widgetName}`).MultiScheduleFeature({
    scriptPath: widgetOpts.scriptPath,
    currentWidgetModuleItemID: widgetOpts.WidgetModuleDataItemID,
    detectIpad: IPADDETECTED,
    isResponsive: false,
    // options
    allEventsLink: true,
    allEventsLinkText: 'VIEW FULL CALENDAR',
    hasImages: false,
    imageBackground: false,
    lazyLoadImages: true,
    buyNowButton: { visible: false, text: 'BUY NOW' },
    moreButton: { visible: false, text: 'MORE' },
    maxItemsVisible: 4,
    hasDescription: false,
    textContainer: true,
    link: 'all', // options are 'all', 'text', 'image', 'imageAndText', or ''
    attributeOrder: {
      1: 'image',
      2: 'title',
      3: 'date',
      4: 'description',
      5: 'buttons',
    },
    multiFeatureLoaded: function (data) {
      if (data.length < 1) {
        $(`#${widgetName}`).remove();
      } else {
        $(`#${widgetName} .all-events-btn`).addClass('button');
        $(`#${widgetName} .featureItem`).each(function (i) {
          // const itemTitle = $(this).find('.featureItemTitle');
          const itemDescripton = $(this).find('.featureItemDescription');
          /* uncomment below if you need to slice the date string up into something shorter like "Oct 31" */
          const eventDate = $(this).find('.featureItemDate');
          formatDate(eventDate);
          /* uncomment below if you need to limit the characters in the title or description text */
          if (itemDescripton.text().length < 1) {
            itemDescripton.remove();
          }
          itemDescripton.text(setCharLimit(itemDescripton, 40));
          /* uncomment below if 'more' text is needed after event description */
          // itemDescripton.append("<span class='more-text'>More</span>");
        });
      }
    },
  });
}

// helper functions
